<template lang="pug">
  .component-backoffice-create-vehicle-slot
    modal-reveal(sizing="small", ref="createVehicleSlotModal")
      button.button.small(slot="trigger") Archive Slot
      h2 Archive
      p Select where to move all past reservations of vehicle slots associated to this parking slot
      .row
        .column
          selectize-grouped-parking-assets(@parkingSlotSelected="setParkingSlot")
      .row.column
        button.button(:disabled="parkingSlot === null", @click="archive") Archive

</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import SelectizeGroupedParkingAssets from '../../lists/selectize/SelectizeGroupedParkingAssets'
  import BookingModeSelect from '../../../BookingModeSelect'

  export default {
    name: 'ArchiveVehicleSlots',
    components: {BookingModeSelect, SelectizeGroupedParkingAssets, ModalReveal},
    created() {

    },
    data() {
      return {
        parkingSlot: null,

      }
    },
    methods: {
      archive() {
        this.$emit('slotForArchiveSelected', this.parkingSlot)
      },
      setParkingSlot(val) {
        this.parkingSlot = val
      }
    },
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ArchiveVehicleSlots.vue?0ce6b8ec